exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pastille[data-v-6c4d7a98]{background-color:#369a6e;position:absolute;top:-10px;right:-10px;border-radius:20px;height:23px;width:23px;font-weight:600}.margin-negative[data-v-6c4d7a98]{margin-top:-.1rem}.linkBlack[data-v-6c4d7a98]{color:#000;text-decoration:none}", ""]);

// exports
